import { Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { Draft } from 'immer';
import React, { useEffect, useState } from 'react';
import { useImmer } from 'use-immer';
import { ID } from '../../../global'; // e.g. type ID = string | number;
import { PageParam } from '@/models/common';
import { trueFilter } from '@/utils/common';
import { SelectorProps } from './createModalSelector';
import { DataSource } from './datasource';
import { Style_Display_None } from '@/utils/uiHelper';

// ------------------ 主组件工厂 ------------------
export const createModalViewer = <T extends object, FilterValue extends object = {}>({
  datasource,
  tableColumns,
  title: factoryTitle = '选择器',
  Filter,
}: {
  datasource: DataSource<T>;
  tableColumns: ColumnsType<T>;
  title?: React.ReactNode;
  Filter?: React.ComponentType<{ onFilter: (filters: FilterValue) => void }>;
}) => {
  return function SelectorComponent(
    props: Omit<SelectorProps<T>, 'value'> & {
      value: (T | ID)[];
    }
  ) {
    const {
      onCancel,
      selectStyle,
      selectClassName,
      dataFilter = trueFilter,
      open,
      title,
      value,
    } = props;
    const [innerOpen, setInnerOpen] = useState(false);
    const [dataList, setDataList] = useState<T[]>();
    const [loading, setLoading] = useState(false);
    const [queryInfo, updateQueryInfo] = useImmer<{ pageParam: PageParam; filter: FilterValue }>({
      pageParam: { current: 1, pageSize: 10 },
      filter: {} as FilterValue,
    });

    const loadData = () => {
      setLoading(true);
      datasource
        .getViewList({
          pageParam: queryInfo.pageParam,
          filter: queryInfo.filter,
          value: value,
        })
        .then(list => {
          const filtered = list.filter(dataFilter);
          setDataList(filtered);
        })
        .finally(() => setLoading(false));
    };

    useEffect(() => {
      if (open) {
        // loadData({ current: 1, pageSize: 1 });
        loadData();
      }
    }, [open, queryInfo]);

    return (
      <>
        <Modal
          maskClosable
          cancelButtonProps={Style_Display_None}
          width={750}
          onOk={onCancel}
          onCancel={onCancel}
          open={open || innerOpen}
          title={title || factoryTitle}>
          {Filter && (
            <Filter
              onFilter={filters => {
                updateQueryInfo(draft => {
                  draft.pageParam.current = 1;
                  draft.filter = filters as Draft<FilterValue>;
                });
              }}
            />
          )}
          <Table<T>
            bordered
            dataSource={dataList}
            columns={tableColumns}
            scroll={{ x: 'max-content' }}
            rowKey={v => datasource.getKey(v)}
            loading={loading}
            style={selectStyle}
            className={selectClassName}
            pagination={{
              ...datasource.getPageInfo(),
              hideOnSinglePage: true,
            }}
            onChange={pageInfo => {
              // loadData();
              updateQueryInfo(draft => {
                draft.pageParam.current = pageInfo.current;
                draft.pageParam.pageSize = pageInfo.pageSize;
              });
            }}
          />
        </Modal>
      </>
    );
  };
};
